// src/lib/person-photo.ts

/**
 * Where every Person.PhotoUrl in the warehouse lives (2026-10-16: all 54 photos, one CloudFront
 * path; the photos My NOS shows). The production CSP lets images, and only images, load from this
 * path (`src/lib/storage/csp.ts`), so a photo is shown only when it is under it.
 */
export const PERSON_PHOTO_SOURCE = "https://d36887svjhykt4.cloudfront.net/users/";

/** A Person.PhotoUrl the browser may load, or null (the avatar shows initials). */
export function personPhotoUrl(raw: string | null | undefined): string | null {
  const url = raw?.trim() ?? "";
  if (!url.startsWith(PERSON_PHOTO_SOURCE)) return null;
  const rest = url.slice(PERSON_PHOTO_SOURCE.length);
  // One plain file name: no path climbing, spaces, quotes or anything that could break out.
  return /^[A-Za-z0-9._-]+$/.test(rest) && !rest.includes("..") ? url : null;
}

/**
 * The avatar's image: a photo the person uploaded in this app (Profile → photo) wins, since they
 * chose it here; otherwise their warehouse photo; otherwise null and the avatar shows initials.
 */
export function avatarImage(
  uploaded: string | null | undefined,
  warehouse: string | null | undefined,
): string | null {
  return uploaded || warehouse || null;
}
